<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>


<script>

export default {

  data () {
    return {
      
    }
  },
  mounted () {
    
  },
  methods: {
    
  }
}
</script>


<style lang="less">
#app {
  height: inherit;
}
body,html {
  height: 100%;
  margin: 0;
}

</style>
